<template>
  <div class='discussion-text py-4'>
    <span v-if="data.card_question.length" v-html="data.card_question[0].question"></span>
  </div>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";
.discussion-text {
  font-size: 14px;
}
</style>

<script>
export default {
  props: ["data"]
};
</script>
